import React from 'react';
import Icon from '@sabre/spark-react-core/icon';
import { func, string, number, object } from 'prop-types';

const Schedule = ({ value, context, rowIndex }) => {
   const handleCalendarIconClick = () => {
      context(rowIndex);
   };
   return (
      <div className='spark-flex justification-between small-icon'>
         <div className='spark-pad-l-1 schedule-truncat'>{value}</div>
         <Icon
            data-testid='schedule-calendar-test-id'
            name='calendar'
            size='md'
            style='line'
            label='schedule'
            className='spark-flex fav-pointer spark-text-center'
            onClick={handleCalendarIconClick}
         />
      </div>
   );
};
Schedule.propTypes = {
   value: string,
   context: func,
   rowIndex: number,
   api: object,
};

export default Schedule;
